import { render } from "./Start.vue?vue&type=template&id=2324d52e"
import script from "./Start.vue?vue&type=script&lang=js"
export * from "./Start.vue?vue&type=script&lang=js"

import "./Start.vue?vue&type=style&index=0&id=2324d52e&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__